import React from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { IRequestCourseModel } from 'models/requestCourse.model'
import { EnrolState } from 'enum'
import TextAreaInput from 'components/ui/forms/field/text-area/TextArea'
import StateEnrol from 'components/ui/state-enrol/StateEnrol'
import { IMainState } from 'store/states'
import { useIsDesktop, useBasicPermission } from 'helpers'
import { prefix } from '../constants'
import styles from './common.module.scss'

interface RequestModeratorProps {
  requestCourse: IRequestCourseModel
  text?: string
  value?: string
  onChange?: (value: string) => void
}

export const RequestModerator: React.FC<RequestModeratorProps> = ({
  requestCourse,
  text,
  value,
  onChange,
}) => {
  const { t } = useTranslation()
  const { permission } = useSelector(({ user }: IMainState) => user)

  const request = requestCourse.state === EnrolState.Pending

  const onDesktop = useIsDesktop()

  const basePermission = useBasicPermission()

  const title = (
    <p className={`${styles.title} grey-darken mt-1`}>
      {t(`${prefix}.response`)}
    </p>
  )
  if (!request)
    return (
      <div>
        {title}
        <p className={`${styles.label} grey-darken mt-1`}>{text}</p>
      </div>
    )
  if (permission.supervisor || basePermission)
    return (
      request && (
        <Form className="mt-2">
          <Form.Group className={styles.requestForm}>
            <Form.Label className={`${styles.formLabel} mb-0`}>
              {t(`${prefix}.response`)}
            </Form.Label>
            <TextAreaInput
              name={'note'}
              placeholder={t(`${prefix}.placeholder`)}
              rows={5}
              label={''}
              value={value}
              onChange={({ target }) => onChange?.(target.value)}
              error={''}
            />
          </Form.Group>
        </Form>
      )
    )

  return (
    <>
      {onDesktop && <hr />}
      <div>
        {title}
        <StateEnrol
          className={styles.label}
          state={requestCourse.stateAdmin}
          iconPosition="right"
        />
      </div>
    </>
  )
}

export default RequestModerator
